// extracted by mini-css-extract-plugin
export default {"block":"a7FcGl","alignXLeft":"b7FcGl","alignXCenter":"c7FcGl","alignXRight":"d7FcGl","alignYTop":"e7FcGl","alignYCenter":"f7FcGl","alignYBottom":"g7FcGl"};